export { default } from './EmprestimoGarantiaCarroContratoVantagens';
